import { render, staticRenderFns } from "./RecoverPasswordPage.vue?vue&type=template&id=0349654b&"
import script from "./RecoverPasswordPage.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0349654b')) {
      api.createRecord('0349654b', component.options)
    } else {
      api.reload('0349654b', component.options)
    }
    module.hot.accept("./RecoverPasswordPage.vue?vue&type=template&id=0349654b&", function () {
      api.rerender('0349654b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/RecoverPasswordPage.vue"
export default component.exports